import React from 'react';

const ParticipateSection = () => (
  <>
    <div className="bg-gradient-to-r from-saffron to-gold text-black rounded-xl p-8 text-center shadow-temple">
      <h3 className="text-2xl font-bold mb-4 text-black">
        Come and Participate in the Mahotsavam
      </h3>
      <p className="text-base mb-6 text-black">
        Join us during the annual Mahotsavam to experience the divine grace of Sree Rajagopala Krishnaswamy 
        and be part of this centuries-old tradition of devotion and celebration.
      </p>
      <div className="flex flex-col space-y-4 items-center">
        <button
          onClick={() => document.getElementById('donations')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-gold text-saffron px-8 py-3 rounded-full font-semibold hover:bg-yellow-200 transition-colors w-full md:w-auto"
          data-testid="support-mahotsavam-btn"
        >
          Participate in the Mahotsavam through Sevas
        </button>
      </div>
      
      <div className="text-center mt-8">
        <img
          src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/njyy9512_DocScanner%20Mar%2015%2C%202026%2011-42%20AM.jpg"
          alt="Temple Dhwaja flag during Mahotsavam"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
      
      <div className="text-center mt-8">
        <img
          src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/6w4vluxp_1000023796.png"
          alt="Deity with floral decorations during Mahotsavam"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
    </div>
    <div className="mt-12 text-center">
      <img
        src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/zt4fxz7o_Punapratishtha%20Navathy%20Mahotsav%20commemmorative%20Silver%20Lockets%20are%20available_20250930_175958_0000.png"
        alt="Punaprathishta Navathy Mahotsav commemorative Silver Lockets are available"
        className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
      />
    </div>
  </>
);

export default ParticipateSection;
